/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PopularGenresResponse,
} from '../models';
import {
    PopularGenresResponseFromJSON,
    PopularGenresResponseToJSON,
} from '../models';

export interface GetPopularGenresRequest {
    startTime?: number;
    limit?: number;
    offset?: number;
    minCount?: number;
}

/**
 * 
 */
export class GenresApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Get popular genres from recently created tracks.
     */
    async getPopularGenresRaw(params: GetPopularGenresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PopularGenresResponse>> {
        const queryParameters: any = {};

        if (params.startTime !== undefined) {
            queryParameters['start_time'] = params.startTime;
        }

        if (params.limit !== undefined) {
            queryParameters['limit'] = params.limit;
        }

        if (params.offset !== undefined) {
            queryParameters['offset'] = params.offset;
        }

        if (params.minCount !== undefined) {
            queryParameters['min_count'] = params.minCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/genres/popular`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PopularGenresResponseFromJSON(jsonValue));
    }

    /**
     * Get popular genres from recently created tracks.
     */
    async getPopularGenres(params: GetPopularGenresRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PopularGenresResponse> {
        const response = await this.getPopularGenresRaw(params, initOverrides);
        return await response.value();
    }

}
